import React from "react";
import { ArrowRight, Lock } from "lucide-react";
import Nav from "../site/Nav";
import Footer from "../site/Footer";
import IosInstallPrompt from "../site/IosInstallPrompt";

/** Token-entry gate for the admin intakes dashboard. Token persists in
 *  sessionStorage only. `onUnlock(token)` is called with the trimmed token. */
export default function AdminTokenGate({ tokenInput, setTokenInput, error, onUnlock }) {
  return (
    <div className="bg-sand-100 text-ink min-h-screen" data-testid="admin-intakes-page">
      <Nav />
      <main className="pt-28 sm:pt-32 md:pt-36 pb-20 px-5 sm:px-6 md:px-10">
        <div className="max-w-md mx-auto">
          <div className="rounded-3xl border border-sand-300 bg-sand-50 p-8 sm:p-10">
            <span className="inline-flex h-11 w-11 grid place-items-center rounded-full bg-clay/10 text-clay border border-clay/30">
              <Lock size={18} />
            </span>
            <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-clay">
              Admin · Intakes
            </p>
            <h1 className="font-display mt-3 text-[2rem] sm:text-[2.4rem] leading-[1.1] tracking-[-0.02em] font-semibold text-ink">
              Enter admin token
            </h1>
            <p className="mt-4 text-[14px] text-ink-muted leading-relaxed">
              This view lists every Website Build Brief submission and flips green when Stripe confirms payment. Token lives only in this browser session.
            </p>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (!tokenInput.trim()) return;
                onUnlock(tokenInput.trim());
              }}
              className="mt-8 space-y-4"
            >
              <input
                type="password"
                value={tokenInput}
                onChange={(e) => setTokenInput(e.target.value)}
                placeholder="paste ADMIN_TOKEN"
                data-testid="admin-token-input"
                className="w-full h-12 rounded-xl border border-sand-300 bg-sand-50 px-4 text-ink placeholder:text-ink-muted/50 focus:border-clay focus:outline-none focus:ring-2 focus:ring-clay/20 transition-colors"
              />
              {error && <p className="text-[12.5px] text-clay">{error}</p>}
              <button
                type="submit"
                data-testid="admin-token-submit"
                className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-ink-deep text-sand-100 px-6 py-3.5 text-[14px] font-medium hover:bg-rust transition-colors min-h-[48px]"
              >
                Unlock
                <ArrowRight size={14} />
              </button>
            </form>
          </div>
        </div>
      </main>
      <Footer />
      <IosInstallPrompt />
    </div>
  );
}
